
  import Vue from 'vue'

  export default Vue.extend({
    name: 'Home',
    created() {
      document.title = this.$vuetify.lang.t("$vuetify.tab_titles.home")
    }
  })
